// extracted by mini-css-extract-plugin
export default {"loading":"Spinner_loading__4I6qv","spinner":"Spinner_spinner__Z6H3Z"};